import styled from 'styled-components';

export const NoteDialogWrapper = styled.div``;

export const Div = styled.div``;
